// @flow
import * as React from 'react';

import { ProductContext } from '../../../modules/ProductContext';
import { useConfigurationDetailsUpSell } from '../modules/webhosting';

import type { Options } from './PlanContent';
import { PlanRow, type Props as PlanRowProps } from './PlanRow';

export type Props = Omit<PlanRowProps, 'options' | 'id'>;

export function PlanRowWithOptions({ ...props }: Props): React.MixedElement {
  const product = React.useContext(ProductContext);

  const { cpu, storage, mailbox } =
    useConfigurationDetailsUpSell({
      duration: product.payload.duration || 1,
      // $FlowFixMe[incompatible-call]
      size: props.value,
    }) || {};

  const displayMailbox = cpu && storage;

  // For the type Flow
  const options = [storage, cpu, displayMailbox ? mailbox : undefined].reduce(
    (acc, value) => {
      if (value) {
        acc.push({ id: value, content: value });
      }
      return acc;
    },
    ([]: Options),
  );

  return <PlanRow {...props} id={product.id} options={options} />;
}
